
import MealOverviewGrid from "../components/MealOverviewGrid";
import { colors, space, radius, borders } from "../design/tokens";

import {
  Screen,
  Content,
  Card,
  TextInput,
  Button,
  Text,
  Row
} from "../components/layout";

export default function MealPage() {
    return(
        <>
            <Screen>
                <Content>
                    <Card style={{
                    padding: space.sm,
                    gap: space.lg
                    }}
                    >
                        <MealOverviewGrid />

                    </Card>
                </Content>
            </Screen >
        </>
    )
}